<template>
  <!-- ヘッダー -->
  <DbsHeader
    :headerTitle="pageType == 'using' ? '利用内容確認' : '予約内容確認'"
    :clickBackButtonEvent="backToDbsIndexPage"
  />

  <div class="content-block">
    <div class="block">
      <CycleInfo label="バイク番号" :value="cycle.cyc_name" />
    </div>
  </div>

  <div v-if="myCouponTickets.length > 0" class="coupon-block">
    <p class="block-title">クーポンのご利用</p>
    <DbsCouponTicketsRadio
      :couponTickets="myCouponTickets"
      v-model:selectedCouponIndex="selectedCouponIndex"
    />
  </div>

  <div class="fixed-buttons">
    <div class="link-buttons">
      <DbsHowToUseLinkButton />

      <DbsTermsLinkButton />
    </div>

    <DbsBookingBottomButton
      :selectedCouponId="selectedCouponId"
      :pageType="pageType"
    />
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateDbsBookingConfirmation",
  props: {
    pageType: {
      type: String, // using or booking
      required: true,
    },
  },
  setup() {
    const store = useStore();

    const cycle = store.getters["dbs/cycle"];

    const myCouponTickets = computed(() => {
      const _tickets = store.getters["dbs/myCouponTickets"];
      // クーポンを所持している場合は、選択用に「利用しない」を追加して代入する
      if (_tickets.length > 0) {
        return [{ pass_name: "利用しない" }, ..._tickets];
      } else {
        // 未所持の場合は空配列
        return [];
      }
    });
    const selectedCouponIndex = ref(0);
    const selectedCouponId = computed(() => {
      if (myCouponTickets.value.length > 0) {
        return myCouponTickets.value[selectedCouponIndex.value].pass_id;
      } else {
        return null;
      }
    });

    const backToDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsWithClose();
    };

    return {
      cycle,
      myCouponTickets,
      selectedCouponIndex,
      selectedCouponId,
      backToDbsIndexPage,
    };
  },
};
</script>
<style scoped>
.content-block {
  width: 100%;
  padding: 0 10px 16px;
  margin-bottom: 30px;
}
.content-block .block {
  display: table;
  font-size: 13px;
}
.coupon-block {
  width: 100%;
  margin-bottom: 300px;
}
.block-title {
  font-size: 16px;
  font-weight: bold;
  margin: 14px;
}
.fixed-buttons {
  position: fixed;
  z-index: 900;
  background-color: white;
  left: 0;
  bottom: 0px;
  width: 100%;
}
.fixed-buttons .link-buttons {
  padding: 10px;
}
</style>
